module.exports = __webpack_public_path__ + "static/media/0222_IMG_LA_BOUCHERIE.9f74202a.webp";